import { CustomLink } from "@/components";
import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetTitle,
    SheetTrigger,
} from "@/components/ui/sheet";
import { cn } from "@/services/hooks/utils";
import { useRouterState } from "@tanstack/react-router";
import { MoreHorizontal } from "lucide-react";
import { useState } from "react";
import {
    getActiveUserNavHref,
    primaryMobileNavItems,
    secondaryMobileNavItems,
} from "./userNavItems";

export const BottomNav = () => {
    const [moreOpen, setMoreOpen] = useState(false);
    const pathname = useRouterState({
        select: (state) => state.location.pathname,
    });
    const activeHref = getActiveUserNavHref(pathname);

    return (
        <nav className="fixed inset-x-0 bottom-0 z-50 border-t bg-white/95 px-2 pb-[calc(env(safe-area-inset-bottom)+0.35rem)] pt-2 shadow-[0_-8px_20px_rgba(15,23,42,0.08)] backdrop-blur lg:hidden">
            <div className="mx-auto grid max-w-md grid-cols-5 items-center gap-1">
                {primaryMobileNavItems.map((item) => {
                    const Icon = item.icon;
                    const isActive = activeHref === item.href;

                    return (
                        <CustomLink
                            key={item.href}
                            to={item.href as never}
                            className={cn(
                                "flex min-h-12 flex-col items-center justify-center gap-1 rounded-md px-1 text-[11px] font-semibold leading-none transition-colors",
                                "text-muted-foreground hover:bg-primary/10 hover:text-primary",
                                isActive && "bg-primary/10 text-primary",
                            )}
                        >
                            <Icon className="h-5 w-5" />
                            <span className="max-w-full truncate">
                                {item.title}
                            </span>
                        </CustomLink>
                    );
                })}
                <Sheet open={moreOpen} onOpenChange={setMoreOpen}>
                    <SheetTrigger className="flex min-h-12 flex-col items-center justify-center gap-1 rounded-md px-1 text-[11px] font-semibold leading-none text-muted-foreground hover:bg-primary/10 hover:text-primary">
                        <MoreHorizontal className="h-5 w-5" />
                        <span>Más</span>
                    </SheetTrigger>
                    <SheetContent side="bottom" className="rounded-t-xl pb-8">
                        <SheetHeader>
                            <SheetTitle>Más opciones</SheetTitle>
                        </SheetHeader>
                        <div className="mt-4 grid grid-cols-2 gap-2">
                            {secondaryMobileNavItems.map((item) => {
                                const Icon = item.icon;
                                const isActive = activeHref === item.href;

                                return (
                                    <CustomLink
                                        key={item.href}
                                        to={item.href as never}
                                        onClick={() => setMoreOpen(false)}
                                        className={cn(
                                            "flex min-h-12 items-center gap-3 rounded-md border px-3 py-2 text-sm font-medium",
                                            "text-muted-foreground hover:bg-primary/10 hover:text-primary",
                                            isActive &&
                                                "border-primary/30 bg-primary/10 text-primary",
                                        )}
                                    >
                                        <Icon className="h-5 w-5 shrink-0" />
                                        <span>{item.title}</span>
                                    </CustomLink>
                                );
                            })}
                        </div>
                    </SheetContent>
                </Sheet>
            </div>
        </nav>
    );
};
